import { defineComponent as _defineComponent } from 'vue'
import { COUNTRY_WITHOUT_TITLEDETAIL } from '@/constants/web-locales.constant';

import { useRoute } from 'vue-router/composables';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';

import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const AppDefaultFooter = () =>
	import(/* webpackChunkName: "default-footer" */ '@/components/footer/AppDefaultFooter.vue');
const AppFooterEuropeanBanner = () =>
	import(/* webpackChunkName: "european-banner-footer" */ '@/components/footer/AppFooterEuropeanBanner.vue');

const route = useRoute();
const languageStore = useLanguageStore();
const { urlMetadataPromise } = storeToRefs(useRoutingStore());
const { isUserOnboarded } = storeToRefs(useUserStore());

const showAnyFooter = computed(() => !COUNTRY_WITHOUT_TITLEDETAIL.includes(languageStore.webLocale));

const showEuropeanFooterBanner = computed(() => route.name === 'app.home' && !isUserOnboarded.value);

const metaReady = ref(false);
const coldStart = ref(true);

onMounted(() => {
	coldStart.value = false;
});

start();

// setup
async function start() {
	await urlMetadataPromise.value;
	metaReady.value = true;
}

return { __sfc: true,AppDefaultFooter, AppFooterEuropeanBanner, route, languageStore, urlMetadataPromise, isUserOnboarded, showAnyFooter, showEuropeanFooterBanner, metaReady, coldStart, start }
}

})